export const VERTICAL_READINESS = {
  tag: "VERTICAL-READY DEPLOYMENTS",
  headline: "One infrastructure.",
  headlineAccent: "An AI Employee configured for every client niche.",
  subline:
    "Service catalog, qualification rules, and brand voice, tuned per deployment instead of one generic script.",
  niches: ["Home Services", "Medical", "Real Estate"],
  nichesMore: "and more",
};
